module.exports = __webpack_public_path__ + "assets/img/3_1199_big.cf54e9bc.jpg";